import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { LoaderEvent } from './../../shared/message.event';
import { CONSTANT_VALUES } from '../../constants/constant-values';

@Component({
    selector: 'app-edit-group',
    templateUrl: './edit-group.component.html',
    styleUrls: ['./edit-group.component.css'],
    providers: [LoaderEvent],
    exportAs: 'editGroupPopupObj'
})
export class EditGroupComponent implements OnInit {
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    @Output() notify = new EventEmitter<any>();
    @Input() groupName;
    private group = {
        'groupName': '',
        'description': ''
    }
    private popUpMessage = '';
    private validate = {
        'name': '',
        'description': ''
    };

    constructor(private loaderEvent: LoaderEvent) {
        this.group.groupName = this.groupName;
    }

    public showChildModal(description): void {
        this.group.groupName = this.groupName;
        this.group.description = description;
        this.validateGroupDetails('');
        this.childModal.config.backdrop = false;
        this.childModal.show();
    }

    public hideChildModal(): void {
        this.childModal.hide();
    }

    ngOnInit() {
    }

    /**
     * Update group name
     */
    updateGroup(popUpObj) {
        if (this.validateGroupDetails('')) {
            this.notify.emit(this.group);
            this.hideChildModal();
        } else {
        }
    }

    /**
     * Validate group name
     */
    validateGroupDetails(para) {
        let validateFlag = true;
        switch (para) {
            case 'name':
                if (!(this.group.groupName + '').trim()) {
                    this.group.groupName = '';
                    this.validate.name = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    validateFlag = false;
                } else {
                    this.validate.name = '';
                }
                break;
            case 'description':
                if (!(this.group.description + '').trim()) {
                    this.group.description = '';
                    this.validate.description = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    validateFlag = false;
                } else {
                    this.validate.description = '';
                }
                break;
            default:
                if (!(this.group.groupName + '').trim()) {
                    this.group.groupName = '';
                    this.validate.name = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    validateFlag = false;
                } else {
                    this.validate.name = '';
                }
                if (!(this.group.description + '').trim()) {
                    this.group.description = '';
                    this.validate.description = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    validateFlag = false;
                } else {
                    this.validate.description = '';
                }
                break;
        }
        return validateFlag;
    }
}



// WEBPACK FOOTER //
// ./src/app/group/edit-group/edit-group.component.ts